import { Player } from './styled';

export default Player;
